<template>
  <div class="user-management">
    <template>
      <h4 style="color: aliceblue;margin-top: -30px">
        {{title}}
      </h4>
    </template>
    <el-row :gutter="40">
      <el-col :span="24" :xs="24">
        <el-form ref="queryForm" :inline="true" :model="queryParams" label-width="68px" size="small">
          <el-form-item>
            <el-button icon="el-icon-plus" type="primary" @click="handleAdd">新增
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-input v-model="queryParams.name" placeholder="请输入姓名" />
          </el-form-item>
          <el-form-item>
            <el-date-picker v-model="queryParams.Time" prefix-icon="el-icon-date" type="datetimerange"
              start-placeholder="申报开始日期" end-placeholder="申报结束日期" size="small" value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-select v-model="queryParams.checkStatus" placeholder="审批状态">
              <el-option label="全部" value="" />
              <el-option v-for="item in checkstatus" :key="item.code" :label="item.name" :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="handleQuery">搜索</el-button>
            <!-- <el-button icon="el-icon-refresh" @click="handleReset"
              >重置</el-button
            > -->
          </el-form-item>
        </el-form>

        <el-table v-loading="loading" element-loading-text="数据载入中" element-loading-spinner="el-icon-loading"
          :data="pageList" :show-overflow-tooltip="true">

          <el-table-column align="center" label="姓名" prop="name" width="100" />
          <el-table-column align="center" label="联系方式" prop="mobile" width="110" />
          <el-table-column align="center" label="身份证号" prop="idCard" width="166" />
          <el-table-column align="center" label="性别" prop="sex" width="80" />
          <el-table-column align="center" label="年龄" prop="age" width="80" />
          <el-table-column align="center" label="人员状态" width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.personStatus == 1">在职</span>
              <span v-if="scope.row.personStatus == 2">离职</span>
              <span v-if="scope.row.personStatus == 99">其他</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="到访企业" prop="coName" />
          <el-table-column align="center" label="有效期始" prop="validityPeriodStart" width="100" />
          <el-table-column align="center" label="有效期止" prop="validityPeriodEnd" width="100" />
          <el-table-column align="center" label="通行类型" prop="passType" width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.passType == 1">人脸用户</span>
              <span v-if="scope.row.passType == 2">IC卡用户</span>
              <span v-if="scope.row.passType == 3">人脸+IC卡用户</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="申报时间" prop="createTime" width="100" />
          <el-table-column align="center" label="审批状态" prop="checkStatus" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.checkStatus == 0"><b>未审批</b></span>
              <span v-if="scope.row.checkStatus == 1" style="color: green;"><b>审批通过</b></span>
              <span v-if="scope.row.checkStatus == 2" style="color: red;"><b>审批未通过</b></span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="事由" prop="reason" width="100"  v-if="declareType == 2" show-overflow-tooltip/>
          <el-table-column align="center" label="备注" prop="remark" width="100"  v-if="declareType != 2" show-overflow-tooltip/>
          <el-table-column align="center" label="操作" width="180">
            <template slot-scope="scope">
              <el-button v-if="scope.row.checkStatus != 0" type="info" size="mini" circle plain
                @click.stop="handleDetail(scope.row,1)">再次申报</el-button>
              <el-button type="success" size="mini" circle plain @click.stop="handleDetail(scope.row,2)">详情</el-button>
              <el-button type="danger" icon="el-icon-delete" size="mini" circle plain
                @click.stop="handleDelete(scope.row)" />
            </template>
          </el-table-column>
        </el-table>

        <commonPagination :page="pagination" :pageSizes="[10, 20, 30, 40, 50, 100]" :getList="handleQuery">
        </commonPagination>
      </el-col>
    </el-row>

    <!-- 新增或修改参数配置对话框 -->
    <el-dialog :title="dialog.title" :visible.sync="dialog.visible" width="800px">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="到访企业" prop="coId">
              <el-select v-model="form.coId" filterable placeholder="请输入或选择" :disabled="disabled">
                <el-option v-for="item in company" :key="item.value" :label="item.lable" :value="parseInt(item.value)" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="进入区域" prop="intoArea">
              <el-select v-model="form.intoArea" placeholder="请选择" prop="intoArea" :disabled="disabled">
                <el-option v-for="item in intoAreas" :key="item.value" :label="item.name" :value="parseInt(item.code)" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="姓名" prop="name">
              <el-input v-model="form.name" placeholder="请输入姓名" :disabled="disabled"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系方式" prop="mobile">
              <el-input v-model="form.mobile" placeholder="请输入手机号" type="number" oninput="if(value.length>11)value=value.slice(0,11)" :disabled="disabled"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证号" prop="idCard">
              <el-input v-model="form.idCard" placeholder="请输入身份证" :disabled="disabled"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="性别" prop="sex">
              <el-select v-model="form.sex" placeholder="请选择" prop="sex" :disabled="disabled">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="年龄" prop="age">
              <el-input v-model="form.age" placeholder="请输入年龄" type="number" :disabled="disabled"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="人员状态" prop="personStatus">
              <el-select v-model="form.personStatus" placeholder="请选择" :disabled="disabled">
                <el-option v-for="item in personstatus" :key="item.value" :label="item.name" :value="parseInt(item.code)" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.declareType == 2">
            <el-form-item label="进出日期" prop="validityPeriodStart">
              <el-date-picker v-model="form.validityPeriodStart"  value-format="yyyy-MM-dd"
                type="date" :picker-options="pickerOptions" :disabled="disabled"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.declareType != 2">
            <el-form-item label="有效期始" prop="validityPeriodStart">
              <el-date-picker v-model="form.validityPeriodStart"  value-format="yyyy-MM-dd"
                type="date" :picker-options="pickerOptions" :disabled="disabled"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.declareType != 2">
            <el-form-item label="有效期止" prop="validityPeriodEnd">
              <el-date-picker v-model="form.validityPeriodEnd"  value-format="yyyy-MM-dd"
                type="date" :picker-options="pickerOptions" :disabled="disabled"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.declareType != 2">
            <el-form-item label="每日访问时段" prop="passTime">
              <el-time-picker is-range value-format="HH:mm:ss" placeholder="选择时间" range-separator="-" size="mini"
                v-model="form.passTime1" class="u-w-80" :disabled="disabled"></el-time-picker>
              <el-time-picker is-range value-format="HH:mm:ss" placeholder="选择时间" range-separator="-" size="mini"
                v-model="form.passTime2" class="u-w-80" :disabled="disabled"></el-time-picker>
              <el-time-picker is-range value-format="HH:mm:ss" placeholder="选择时间" range-separator="-" size="mini"
                v-model="form.passTime3" class="u-w-80" :disabled="disabled"></el-time-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="通行类型" prop="passType">
              <el-select v-model="form.passType" placeholder="请选择" :disabled="disabled">
                <el-option v-for="item in passtype" :key="item.value" :label="item.name" :value="parseInt(item.code)" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="事由" prop="reason" v-if="form.declareType == 2">
              <el-input v-model="form.reason" placeholder="" type="textarea" :disabled="disabled"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备注" prop="remark">
              <el-input v-model="form.remark" placeholder="" type="textarea" :disabled="disabled"/>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="!dialog.flag">
            <el-form-item label="审批意见" prop="checkOpinion">
              <el-input v-model="form.checkOpinion" placeholder="" type="textarea" :disabled="disabled"/>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="dialog.flag">
            <el-form-item label="头像照片" prop="avatar">
              <el-upload ref="upload" list-type="picture-card" action="#" :file-list="fileList" :multiple="false" :on-remove="(file,fileList)=>{ removeFile(file,fileList, 'avatar')}"
                 :limit="1" :auto-upload="true" :http-request="(file,fileList)=>{ upload(file,fileList, 'avatar')}" :before-upload="beforeAvatarUpload">
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!dialog.flag">
            <el-form-item label="头像照片" prop="avatar">
              <img :src="form.avatar" width="100%" alt="" height="180px" @click="handlePictureCardPreview(form.avatar)">
            </el-form-item>
          </el-col>
        <el-col :span="24" v-if="dialog.flag && form.declareType == 2">
          <el-form-item label="健康码" prop="ykCode">
            <el-upload ref="upload1" list-type="picture-card" action="#" :multiple="false" :limit="1" :on-remove="(file,fileList)=>{ removeFile(file,fileList, 'ykCode')}"
              :auto-upload="true" :file-list="fileList1" :http-request="(file,fileList)=>{ upload(file,fileList, 'ykCode')}" :before-upload="beforeAvatarUpload">
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="!dialog.flag && form.declareType == 2">
          <el-form-item label="健康码" prop="ykCode">
            <img :src="form.ykCode" width="100%" alt="" height="180px" @click="handlePictureCardPreview(form.ykCode)">
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="dialog.flag && form.declareType == 2">
          <el-form-item label="行程码" prop="xcCode">
            <el-upload ref="upload2" list-type="picture-card" action="#" :multiple="false" :limit="1" :on-remove="(file,fileList)=>{ removeFile(file,fileList, 'xcCode')}"
              :file-list="fileList2" :auto-upload="true" :http-request="(file,fileList)=>{ upload(file,fileList, 'xcCode')}" :before-upload="beforeAvatarUpload">
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="!dialog.flag && form.declareType == 2">
          <el-form-item label="行程码" prop="xcCode">
            <img :src="form.xcCode" width="100%" alt="" height="180px" @click="handlePictureCardPreview(form.xcCode)">
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="dialog.flag && form.declareType == 2">
          <el-form-item label="核酸报告" prop="yyCode">
            <el-upload ref="upload3" list-type="picture-card" action="#" :multiple="false" :limit="1" :on-remove="(file,fileList)=>{ removeFile(file,fileList, 'yyCode')}"
              :file-list="fileList3" :auto-upload="true" :http-request="(file,fileList)=>{ upload(file,fileList, 'yyCode')}" :before-upload="beforeAvatarUpload">
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="!dialog.flag && form.declareType == 2">
          <el-form-item label="核酸报告" prop="yyCode">
            <img :src="form.yyCode" width="100%" alt="" height="180px" @click="handlePictureCardPreview(form.yyCode)">
          </el-form-item>
        </el-col>
        <!-- <el-col :span="24" v-if="dialog.flag && form.declareType == 1">
            <el-form-item label="港区证明文件" prop="proveFile">
              <el-upload ref="upload4" list-type="picture-card" action="#" :file-list="fileList4" :multiple="false" :on-remove="(file,fileList)=>{ removeFile(file,fileList, 'proveFile')}"
                :limit="1" :auto-upload="true" :http-request="(file,fileList)=>{ upload(file,fileList, 'proveFile')}" :before-upload="beforeAvatarUpload">
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="dialog.flag && form.declareType == 1">
            <el-form-item label="港区文件范例" prop="proveFile">
              <img src="http://huagongyq.dingpod.cn/file/gqzmwj.jpg" width="100%" alt="" height="180px" @click="handlePictureCardPreview('http://huagongyq.dingpod.cn/file/gqzmwj.jpg')">
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!dialog.flag && form.declareType == 1">
            <el-form-item label="港区证明文件" prop="proveFile">
              <img :src="form.proveFile" width="100%" alt="" height="180px" @click="handlePictureCardPreview(form.proveFile)">
            </el-form-item>
          </el-col> -->
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" v-if="dialog.flag">
        <el-button type="primary" @click="handleSubmit">提 交</el-button>
        <el-button @click="dialog.visible = false">取 消</el-button>
      </div>
    </el-dialog>

    <el-image-viewer
      v-if="!!bigImgSrc"
      :on-close="closeImgViewer"
      :url-list="[bigImgSrc]"
    />

  </div>
</template>

<script>
  import commonPagination from "@/components/commonPagination.vue";
  import ElImageViewer from "@/components/CustomImageViewer";
  import store from '@/vuex';
  export default {
    name: "RySb",
    components: {
      commonPagination,ElImageViewer
    },
    props: ["declareType"],
    data() {
      const typeTime = {
        beginTime: this.$myPlug.timeFormat(
          new Date().getTime(),
          "yyyy-mm-dd 00:00:00"
        ),
        endTime: this.$myPlug.timeFormat(new Date().getTime(), "yyyy-mm-dd 23:59:59"),
      };
      return {
        pickerOptions: {
          disabledDate(time) {
          return time.getTime() < Date.now()- 8.64e7;
        }},
        title:JSON.stringify(store.state.documentTitle_menuName).split('"')[3],
        fileList: [],
        fileList1: [],
        fileList2: [],
        fileList3: [],
        fileList4: [],
        disabled: false,
        checkstatus: JSON.parse(sessionStorage.getItem('dictionary')).CHECKSTATUS,
        personstatus:JSON.parse(sessionStorage.getItem('dictionary')).PERSONSTATUS,
        passtype:JSON.parse(sessionStorage.getItem('dictionary')).PERSONPASSTYPE,
        company:JSON.parse(localStorage.getItem('company')),
        intoAreas: [
          {value:1, name: '滨海大道西侧', code: '1'},
          {value:2, name: '滨海大道东侧', code: '2'},
          {value:3, name: '棕榈路北侧', code: '3'},
          {value:4, name: '海河大道北侧', code: '4'},
          {value:5, name: '翁金线西侧', code: '5'},
          {value:6, name: '翁金线东侧', code: '6'},
        ],
        options: [{
          value: '男',
          label: '男'
        }, {
          value: '女',
          label: '女'
        }],
        bigImgSrc: "",
        loading: true,
        // 选中数组
        ids: [],
        // 非单个禁用
        single: true,
        // 非多个禁用
        multiple: true,
        queryParams: {
          declareType: this.declareType,
          Time: Object.values(typeTime),
        },
        pagination: {
          pageIndex: 1,
          pageRow: 10,
          total: 0
        },
        pageList: [],
        dialog: {
          title: undefined,
          visible: false,
          flag: true
        },
        apiUrl: {
          delApi: 'GET_hyPersonDeclareDelete',
          addApi: 'POST_hyPersonDeclareAdd',
          detailApi: 'GET_hyPersonDeclareFind',
          indexApi: 'POST_hyPersonDeclareIndex'
        },
        // 表单参数
        form: {
          age: 0,
          avatar: "",
          coId: "",
          declareType: 1,
          idCard: "",
          mobile: "",
          name: "",
          passTime: "00:00:00-23:59:59",
          passTime1: "00:00:00-23:59:59",
          passType: "",
          personStatus: "",
          reason: "",
          remark: "",
          sex: "",
          validityPeriodEnd: "",
          validityPeriodStart: "",
          ykCode: "",
          xcCode: "",
          yyCode: "",
          proveFile: ""
        },
        // 表单校验
        rules: {
          coId: [{
            required: true,
            message: "企业不能为空",
            trigger: "blur"
          }],
          name: [{
            required: true,
            pattern: /^[\u4e00-\u9fa5a-zA-Z]+$/,
            message: "姓名只能是中文或英文(请勿输入空格)",
            trigger: "blur"
          }],
          mobile: [{
            required: true,
            pattern: /\d{11}$/,
            message: "请输入正确的手机号码",
            trigger: "blur"
          }],
          idCard: [{
            required: true,
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: "请输入正确的身份证号",
            trigger: "blur"
          }],
          sex: [{
            required: true,
            message: "性别不能为空",
            trigger: "blur"
          }],
          validityPeriodStart: [{
            required: true,
            message: "不能为空",
            trigger: "blur"
          }],
          validityPeriodEnd: [{
            required: true,
            message: "不能为空",
            trigger: "blur"
          }],
          personStatus: [{
            required: true,
            message: "不能为空",
            trigger: "blur"
          }],
          avatar: [{
            required: true,
            message: "头像不能为空",
            trigger: "blur"
          }],
          // ykCode: [{
          //   required: true,
          //   message: "健康码不能为空",
          //   trigger: "blur"
          // }],
          // xcCode: [{
          //   required: true,
          //   message: "行程码不能为空",
          //   trigger: "blur"
          // }],
          // yyCode: [{
          //   required: true,
          //   message: "核酸报告不能为空",
          //   trigger: "blur"
          // }]
        }
      };
    },
    methods: {
      async loadData() {
        this.handleQuery();
      },
      handleQuery(obj = {}) {
        if ("pageNo" in obj) {
          this.queryParams.pageIndex = this.pagination.pageIndex = obj.pageNo;
        } else {
          this.queryParams.pageIndex = 1;
        }
        if ("pageSize" in obj) {
          this.queryParams.pageRow = this.pagination.pageRow = obj.pageSize;
        } else {
          this.queryParams.pageRow = this.pagination.pageRow;
        }
        this.queryParams.beginTime = "";
        this.queryParams.endTime = "";
        if(this.queryParams.Time != null){
          this.queryParams.beginTime = this.queryParams.Time[0];
          this.queryParams.endTime = this.queryParams.Time[1];
          this.$http[this.apiUrl.indexApi](this.queryParams).then(response => {
            const {
              data,
              total
            } = response;
            this.pageList = data;
            this.pagination.total = total;
            this.loading = false;
          });
        }else{
          this.$message.error("申报时间查询不能为空!");
        }

      },
      handleReset() {
        this.pagination = {
          pageIndex: 1,
          pageRow: 10,
          total: 0
        };
        this.queryParams = {

        };
        this.handleQuery();
      },

      handleAdd() {
        this.resetForm(this.declareType);
        this.dialog = {
          title: "新增申报",
          visible: true,
          flag: true
        };
      },
      async handleDetail(row,type) {
        this.resetForm(this.declareType);
        if (type == 1) {
          this.dialog = {
            title: "再次申报",
            visible: true,
            flag: true
          };
        } else {
          this.dialog = {
            title: "申报详情",
            visible: true,
            flag: false
          };
          this.disabled = true;
        }
        const id = row.id || this.ids;
        this.$http[this.apiUrl.detailApi]({
          paramsID: id
        }).then(response => {
          if(response.code == '00000'){
            this.form = response.data;
            if(type == 1){
              this.fileList.push({'url': response.data.avatar})
              this.fileList1.push({'url': response.data.ykCode})
              this.fileList2.push({'url': response.data.xcCode})
              this.fileList3.push({'url': response.data.yyCode})
              this.fileList4.push({'url': response.data.proveFile})
            }
            if(this.declareType != 2){
              var n = response.data.passTime.split(',')
              for (var i = 1; i <= n.length; i++) {
                this.form["passTime" + i] = n[i - 1];
              }
            }
          }
          else{
            if(response.msg==null)
            this.$message.error("获取数据失败！");
            else{
              this.$message.error(response.msg);
            }
          }

        });
      },

      handleSubmit: function() {
        this.$refs["form"].validate(valid => {
          if (valid) {
              if(this.declareType != 2){
                var time0 = this.form.passTime;
                var time1 = this.form.passTime1;
                var time2 = this.form.passTime2;
                var time3 = this.form.passTime3;
                if (typeof(time1) != 'string' && time1 != null && time1 != '00:00:00-23:59:59') {
                  time0 = time1[0] + '-' + time1[1];
                }else if(time1 != null){
                  time0 = time1;
                }
                if (typeof(time2) != 'string' &&time2 != null) {
                  time0 = time0 + ','+ time2[0] + '-' + time2[1];
                }else if(time2 != null){
                  time0 = time0 + ','+ time2
                }
                if (typeof(time3) != 'string' &&time3 != null) {
                  time0 = time0 + ','+ time3[0] + '-' + time3[1];
                }else if(time3 != null){
                  time0 = time0 + ','+ time3
                }
                if (time0.substr(time0.length - 1, 1) == ',') {
                  time0 = time0.slice(0, time0.length - 1);
                }
                this.form.passTime = time0;
              }
              let day3
              let message = "";
              if(this.declareType == 1){
                day3 = 1096;
                message = "三年";
              }else if(this.declareType == 2){
                day3 = 0;
                message = "一天";
                this.form.validityPeriodEnd = this.form.validityPeriodStart;
              }else{
                day3 = 6;
                message = "7天";
              }
              let day1 = new Date(this.form.validityPeriodStart);
              let day2 = new Date(this.form.validityPeriodEnd);
              if(day1 <= day2){
                  let days = parseInt(Math.abs(day2 - day1) / 1000 / 60 / 60 / 24);
                  if(days<=day3){
                    this.$axios({
                      method: 'post',
                      url: '/dqi-hymanage/hyPersonDeclare/add',
                      timeout: 30000,
                      data: this.form
                    }).then(res => {
                      if (res.code == '00000') {
                        this.$message.success("新增成功");
                        this.dialog.visible = false;
                        this.handleQuery();
                      } else {
                        this.$message.error(res.msg);
                      }
                    })
                  }else{
                    this.$message.error("有效期始到有效期止最长为"+message)
                  }
              }else{
                this.$message.error("有效期止不能早于有效期始!")
              }
          }
        });
      },

      handleDelete(row) {
        const id = row.id;
        this.$confirm('确定要删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http[this.apiUrl.delApi]({
            paramsID: id
          }).then(response => {
            if(response.code == '00000'){
              this.$message.success("删除成功");
              this.handleQuery();
            }else{
              this.$message.error(response.msg);
            }
          });
        }).catch(() => {});
      },

      beforeAvatarUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 6
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 6MB!')
        }
        return isLt2M
      },

      upload(file, fileList,type) {
        let formData = new FormData();
        formData.append('multipartFile', file.file);
        this.$axios({
          method: 'post',
          url:'/dqi-hymanage/upload/upload/'+type,
          //headers:this.headers,
          timeout: 30000,
          data: formData
        }).then(res => {
          if(res.code=='00000'){
            this.form[type] = res.data
           }else{
             this.$message.error(res.msg);
           }
        })
      },

      removeFile(file, fileList,type){
        this.form[type] = "";
      },

      handlePictureCardPreview(file) {
        this.bigImgSrc = file;
      },
      closeImgViewer(){
        this.bigImgSrc = false;
      },

      // 表单重置
      resetForm(declareType) {
        this.form = {
          age: 0,
          avatar: "",
          coId: "",
          declareType: declareType,
          idCard: "",
          mobile: "",
          name: "",
          passTime: "00:00:00-23:59:59",
          passTime1: "00:00:00-23:59:59",
          passType: "",
          personStatus: "",
          reason: "",
          remark: "",
          sex: "",
          validityPeriodEnd: "",
          validityPeriodStart: "",
          ykCode: "",
          xcCode: "",
          yyCode: "",
          proveFile: ""
        };
        this.fileList = [];
        this.fileList1 = [];
        this.fileList2 = [];
        this.fileList3 = [];
        this.fileList4 = [];
        this.disabled = false;
        if (this.$refs["form"]) {
          this.$nextTick(() => {
          this.$refs["form"].resetFields();
          })
        }
      }
    },
    created() {
      this.loadData();
    },
    watch: {
    }
  };
</script>

<style >
.disUoloadSty .el-upload--picture-card{
  display:none;   /* 上传按钮隐藏 */
}

.el-textarea.is-disabled .el-textarea__inner {
    background-color: #F5F7FA;
    border-color: #E4E7ED;
    color: black;
    cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/components/sbgl/rysb.vue